import { analytics } from '@play-co/gcinstant';
import { Tutorial } from 'src/replicant/buruburu/tutorial';
import { TutorialStep } from 'src/replicant/buruburu/tutorial/tutorial.ruleset';
import StateObserver from 'src/StateObserver';
import { showTutorial } from '../tutorial.util';
import { TutorialEvent } from '../TutorialController';
import { TutorialHandler } from './TutorialHandler';

export class ChatWithPetTutorial implements TutorialHandler {
  public readonly step: TutorialStep = 'chatWithPets';

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    const { user } = StateObserver.getState();

    // Should wait for the basic tutorial to finish before showing this tutorial.
    if (!Tutorial.getters(user).isTutorialStepComplete('basicGameplay')) {
      return false;
    }

    const conversationStepAnalytics = {
      $stepIndex: 2,
      $stepName: 'first_conversation',
    };
    if (event === 'conversationStarted') {
      analytics.pushEvent('TutorialStepStart', conversationStepAnalytics);
      return true;
    }
    if (event === 'conversationFinished') {
      analytics.pushEvent('TutorialStepFinish', conversationStepAnalytics);

      await showTutorial('chatWithPets', {
        $stepIndex: 3,
        $stepName: 'chat_with_pets_popup',
      });

      return true;
    }

    return false;
  }
}
